export default function createSteps(steps) {
    let gradation = 1 / steps;
    return Array(steps + 1).fill(0).map((e, i) => i * gradation);
};
